// eslint-disable-next-line import/prefer-default-export
export const hi = {
  dashboard: {
    promoCode: "Promo Code",
    title: "Dashboard",
    no: "No.",
    time: "Time",
    patient_info: "Patient Info",
    type: "Type",
    urgency: "Urgency",
    assigned_to: "Assigned to",
    status: "Status",
    yrs: "Years",
    yes: "Yes",
    new: "New",
    closed: "Closed",
    escalated: "Escalated",
    processing: "Processing",
    new_ticket_created: "New ticket has been raised, check it out !!",
    new_ticket_assignment: "New ticket has been assigned, check it out !!",
    on_call: "ON CALL",
    patient_app: "PATIENT APP",
    all: "All",
    filterBy: "Filter by",
    typeToSearch: "Type to search by name, phone no., ticket no.",
    appointment: "Appointment",
    booked: "Booked",
    notBooked: "Not booked",
    websites: "वेबसाइट",
    domains: "डोमेन",
    searchBy: "सर्च करें:",
    searchByPlaceholder: "नाम या फोन नंबर के आधार पर खोजें",
    clinicId: "क्लिनिक आईडी",
    domainDetail: "डोमेन विवरण",
    viewDetail: "विस्तार से देखें"
  },
  info_title: "जानकारी",
  success_title: "सफलता!",
  error_title: "एरर!",
  adminAccess: "आपको साइन इन करने के लिए व्यवस्थापक पहुंच की आवश्यकता है",
  connecting_chat: "Connecting to chat",
  connecting_chat_failed: "Connection to chat failed",
  topNav: { sign_out: "Sign out" },
  searchConversations: "बातचीत खोजें",
  tickets: {
    add_ticket: "Add Ticket",
    patient_name: "Patient Name",
    error_patient_name: "Provide the patient's name.",
    patient_dob: "Patient Dob",
    gender: "Gender",
    health_problem: "Health problem",
    error_health_problem: "Provide the Health problem.",
    phone_number: "Phone Number",
    error_phone_number: "Provide the valid patient's phone number.",
    location: "Location",
    error_location: "Provide the location",
    price_from: "Price range - From",
    price_to: "Price range - To",
    error_price_from: "Provide the start price range.",
    error_price_to: "Provide the end price range.",
    urgency: "Urgency",
    assigned_to: "Assigned to",
    error_assigned_to: "Select the assignee.",
    close: "Close",
    add: "Add",
    urgent: "Urgent",
    not_urgent: "Not Urgent",
    male: "Male",
    female: "Female",
    edit_ticket: "Edit Ticket"
  },
  ticket_detail_view: {
    ticket_details: "टिकट का विवरण",
    info: "जानकारी",
    activity: "गतिविधि",
    search: "खोज",
    health_problem: "स्वास्थ्य समस्या",
    location: "स्थान",
    fee_range: "शुल्क सीमा",
    changesStatus: "के लिए स्टेटस बदलता है",
    date: "दिनांक:",
    TimeSlot: "टाइम सलाट :",
    BookedOn: "बुक्ड् ओन :",
    doctor: "चिकित्सक:",
    Contact: "संपर्क करें:",
    Clinic: "क्लिनिक:",
    AppointmentDetails: "नियुक्ति का विवरण",
    unverifyTitle: "क्या आप डॉक्टर को सत्यापित करना चाहेंगे",
    VerifyDoctor: "सत्यापित डॉक्टर",
    UnverifyDoctor: "असत्यापित डॉक्टर",
    verifyReason: "डॉक्टर को सत्यापित करने के पीछे क्या कारण है",
    unverifyReason: "क्या आप डॉक्टर को असत्यापित करना चाहेंगे",
    MedicalLicense: "मेडिकल लाइसेंस",
    ClickToView: "देखने के लिए क्लिक करें",
    VerifyStatus: "स्थिति सत्यापित करें",
    VerifiedBy: "के द्वारा सत्यापित",
    VerifiedAt: "सत्यापित किया गया",
    VerifyReason: "कारण का सत्यापन करें",
    chat: "बातचीत"
  },
  year: "वर्ष",
  month: "महीना",
  schedule: {
    updateSchedule: "अपडेट अनुसूची",
    addSchedule: "अनुसूची जोड़ें",
    daily: "रोज",
    mon: "सोम",
    tue: "मंगल",
    wed: "बुध",
    thu: "गुरूवार",
    fri: "शुक्र",
    sat: "शनि",
    sun: "रवि",
    startTime: "प्रारंभ समय",
    closingTime: "समापन समय",
    discounted_schedule: "रियायती समय",
    regular_schedule: "नियमित समय",
    fees: "फीस",
    cancel: "रद्द करें",
    emptyDays: "कृपया दिन का चयन करें",
    emptyTimings: "कृपया समय का चयन करें",
    invalidTiming: "कृपया वैध समय का चयन करें",
    emptyFeesError: "कृपया शुल्क राशि दर्ज करें",
    scheduleInfo: "अनुसूची जानकारी",
    scheduleText: "अनुसूची",
    addedSuccess: "सफलतापूर्वक जोड़ा गया",
    serverError: "आपके अनुरोध को संसाधित करते समय कुछ त्रुटि हुई थी",
    remove: "हटाओ",
    removed: "सफलतापूर्वक हटा दिया गया",
    days: "दिन",
    timings: "समय",
    removeScheduleConfirmText: "क्या आप वाकई इस कार्यक्रम को हटाना चाहते हैं?",
    updateDoctor: "डॉक्टर की जानकारी अपडेट करें",
    updateDoctorSuccess: "डॉक्टर की जानकारी सफलतापूर्वक अपडेट की गई",
    updateFees: "अपडेट शुल्क",
    Next: "Next",
    edit: "Edit",
    delete: "Delete",
    save: "Save"
  },
  domain: {
    dateTime: "दिनांक और समय",
    result: "परिणाम",
    results: "परिणाम",
    markDone: "पूर्ण के रूप में चिह्नित करें",
    all: "सब",
    new: "नया",
    done: "किया",
    delete: "हटाएं",
    update: "अपडेट",
    complete: "पूरा",
    updateUrl: "अपडेट स्थिति",
    confirm: "पुष्टि करें",
    cancel: "रद्द करें",
    enterUrl: "मान्य url",
    enterValidUrl: "मान्य url दर्ज करें",
    domain: "डोमेन",
    domainName: "डोमेन नाम",
    status: "स्थिति",
    filterByType: "फ़िल्टर प्रकार:",
    filterByStatus: "स्थिति द्वारा फ़िल्टर करें:",
    requestedAt: "अनुरोधित",
    completedAt: "पूरा हुआ"
  },
  profile: {
    clinicName: "क्लिनिक का नाम",
    emptyText: "खाली नहीं हो सकता है",
    addressText: "पता",
    zipcode: "पिनकोड",
    city: "शहर",
    selectLocationError: "ड्रॉपडाउन से शहर का चयन करें",
    SearchPlaces: "जगह खोजें",
    state: "राज्य",
    basicInfoSaveSuccess: "प्रोफाइल की जानकारी सफलतापूर्वक अपडेट की गयी है",
    doctorName: "डॉक्टर का नाम",
    isRequired: "ज़रूरी है",
    dateOfBirth: "जन्म की तारीख",
    registrationNumber: "रेजिस्ट्ररेशन नंबर",
    patientsPerHour: "मरीज/ घंटा",
    experience: "अनुभव (साल)",
    bio: "बाइओ",
    next: "अगला",
    updateEducationSuccess: "शिक्षा की जानकारी सफलतापूर्वक अपडेट की गयी है",
    error: "एरर",
    educationExists: "शिक्षा पहले से मोजूद है",
    deleteEducationSuccess: "शिक्षा की जानकारी सफलतापूर्वक हटा दी गयी है",
    educationName: "शिक्षा का नाम",
    action: "कार्य",
    clinicProfile: "क्लिनिक क्लिनिक",
    clinicSaveSuccess: "क्लिनिक क्लिनिक की जानकारी सफलतापूर्वक अपडेट की गयी है",
    doctors: "डॉक्टर"
  },
  ticket: { created_ticket: "created ticket" },

  website: {
    websiteDetail: "क्लिनिक विस्तार",
    clininInfo: "बुनियादी जानकारी",
    photos: "तस्वीरें",
    doctors: "डॉक्टरों",
    services: "सेवाएं",
    packages: "संकुल",
    reviews: "कुलकेर   समीक्षा",
    seo: "वेबसाइट की जानकारी"
  },
  clinic: {
    phone: "फ़ोन नंबर",
    email: "ईमेल",
    name: "नाम",
    area: "क्षेत्र",
    about: "के बारे में",
    address: "पता",
    pincode: "पिन कोड",
    city: "शहर",
    speciality: "विशेषता"
  },
  seo: {
    seoTitle: "शीर्षक",
    seoDescription: "मेटा विवरण",
    googleCode: "गूगल विश्लेषिकी खाता कोड",
    themeUrl: "थीम यूआरएल",
    themeName: "थीम नाम"
  },

  services: {
    serviceId: "Id"
  },
  packages: {
    description: "विवरण",
    new_price: "नया मूल्य",
    valid_till: "मान्य तक",
    photo: "तस्वीर",
    old_price: "पुरानी कीमत"
  },
  doctor: {
    name: "नाम",
    speciality: "विशेषता",
    eductaion: "शिक्षा",
    experience: "अनुभव",
    fees: "फीस",
    gender: "लिंग",
    schedule: "अनुसूची",
    other: "अन्य",
    photoUrl: "फोटो यूआरएल",
    startTime: "समय शुरू",
    endTime: "अंतिम समय"
  },
  photo: {
    type: "प्रकार",
    link: "संपर्क",
    download: "डाउनलोड"
  },
  reviews: {
    created: "बनाया था",
    review: "समीक्षा",
    rating: "रेटिंग"
  },
  signin: {
    signInHeadingText: "Please sign in with your phone number and password",
    enterPhoneNumber: "Please enter phone number",
    passwordRequired: "Please enter the password.",
    password: "Password",
    signInText: "Sign in"
  },
  typeToSeachByName: "Type name press enter",
  searchByName: "Search by name",
  radiusPlaceholder: "त्रिज्या",
  radius: "त्रिज्या (किमी में)",
  go_home: "गो होम"
};
